import React from 'react';
import { Link } from 'react-router-dom';
import FileBase64 from 'react-file-base64';
import 'whatwg-fetch';

import moment from 'moment';
import { itemsPerPage } from 'src/data/params';
import file_upload_rules from 'src/data/file-upload-rules';
import ModalConfirm from '../components/modal/modalConfirm';
import ModalReturnEmployee from '../components/modal/modalReturnEmployee';

import hardwareIcon from 'src/images/icons/hardware.svg';
import virtualIcon from 'src/images/icons/virtual.svg';
import fileIcon from 'src/images/icons/file.svg';
import SubNavBar from '../components/SubNavBar';
import withAuth from 'src/hoc/withAuth';

const apiDealShow = '/api/deal/show/';
const linkDocumentWorkOrder = '/documents/bon-intervention.pdf';
const linkDocumentTrainingSheet = '/documents/fiche-formation.pdf';
const linkToProductHardware = '/dashboard/productHardware/';
const linkToProductVirtual = '/dashboard/productVirtual/';
const apiUpdateInstallation = '/api/stepProduction/updateInstallation/';
const apiInstallationAddFile = '/api/stepProduction/installation/addDocument';
const apiRemoveWorkOrder = '/api/stepProduction/installation/removeWorkOrder/';
const apiRemoveTrainingSheet = '/api/stepProduction/installation/removeTrainingSheet/';
const apiRemoveImage = '/api/stepProduction/installation/removeInstallPicture/';

class AppInstallation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      appViewNavExtended: false, // Extend the menu behind the appViewNav
      selectedView: 1,
      isModalInstalledOpen: false,
      isModalReturnEmployee: false,
      isModalDeleteOpen: false,
      productSelectedId: undefined,
      productSelectedType: undefined,
      textModal: {
        title: undefined,
        message: undefined,
      },
      fileInputsTrainingSheet: [],
      filesTrainingSheet: {},
      fileInputsWorkOrder: [],
      filesWorkOrder: {},
      fileInputsImage: [],
      filesImage: {},
      isVirgin: false, // if virgin -> open modal in order to select the billmaker
      isFinished: false, // if finished -> no need for the "Install All" button
      accordionMenu: new Object(),
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.toggleAppViewNavExtended = this.toggleAppViewNavExtended.bind(this);
    this.addRowWorkOrder = this.addRowWorkOrder.bind(this);
    this.addRowTrainingSheet = this.addRowTrainingSheet.bind(this);
    this.addRowImage = this.addRowImage.bind(this);
    this.removeRowWorkOrder = this.removeRowWorkOrder.bind(this);
    this.removeRowTrainingSheet = this.removeRowTrainingSheet.bind(this);
    this.removeRowImage = this.removeRowImage.bind(this);
    this.postFile = this.postFile.bind(this);
    this.deleteFile = this.deleteFile.bind(this);
    this.openModalDeleteFile = this.openModalDeleteFile.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.markAsInstalled = this.markAsInstalled.bind(this);
    this.markAllInstalled = this.markAllInstalled.bind(this);
    this.markOneInstalled = this.markOneInstalled.bind(this);
    this.refreshAssociations = this.refreshAssociations.bind(this);
    this.checkVirgin = this.checkVirgin.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  componentDidMount() {
    if (this.props.match.params.id) {
      // check if id supplied in the route
      this.refreshAssociations();
    }
    ///////////////////////////////////////
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.id != this.props.match.params.id) {
      // Route reloaded
      this.componentDidMount();
    }
  }

  refreshAssociations() {
    const paramsID = this.props.match.params.id;

    let queryURL = apiDealShow;
    let graphQL =
      '{ deal(id:' +
      paramsID +
      '){ id, ' +
      'stepProd { id, intermediateStageNumber, preparation{ installation{ id, trainingSheets{ id, name }, workOrders{ id, name }, images{ id, name }}, ' +
      'associationsProductsHardware{ id, products{ id, installed, dateInstalled, stickerId }, quoteArticle{ id, quantity, productReference{ id, wording, supplierHardware{ name, url } } } },' +
      'associationsProductsVirtual{ id, products{ id, installed, dateInstalled }, quoteArticle{ id, quantity, productReference{ id, wording, supplierVirtual{ name, url } } } },' +
      ' } } ' +
      '} }';
    queryURL += graphQL;
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          if (data['data']['deal']['stepProd']['preparation']['installation']) {
            if (
              !data['data']['deal']['stepProd']['preparation']['installation']['workOrders'] ||
              data['data']['deal']['stepProd']['preparation']['installation']['workOrders'].length == 0
            ) {
              if (this.state.fileInputsWorkOrder.length < 1) {
                this.addRowWorkOrder();
              }
            }
            if (
              !data['data']['deal']['stepProd']['preparation']['installation']['trainingSheets'] ||
              data['data']['deal']['stepProd']['preparation']['installation']['trainingSheets'].length == 0
            ) {
              if (this.state.fileInputsTrainingSheet.length < 1) {
                this.addRowTrainingSheet();
              }
            }
            if (
              !data['data']['deal']['stepProd']['preparation']['installation']['images'] ||
              data['data']['deal']['stepProd']['preparation']['installation']['images'].length == 0
            ) {
              if (this.state.fileInputsImage.length < 1) {
                this.addRowImage();
              }
            }
            this.checkVirgin(
              data['data']['deal']['stepProd']['preparation']['associationsProductsHardware'],
              data['data']['deal']['stepProd']['preparation']['associationsProductsVirtual']
            ),
              this.setState({
                dealID: data['data']['deal']['id'],
                dataAssociationHardware:
                  data['data']['deal']['stepProd']['preparation']['associationsProductsHardware'],
                dataAssociationVirtual: data['data']['deal']['stepProd']['preparation']['associationsProductsVirtual'],
                savedTrainingSheets: data['data']['deal']['stepProd']['preparation']['installation']['trainingSheets'],
                savedWorkOrders: data['data']['deal']['stepProd']['preparation']['installation']['workOrders'],
                savedImages: data['data']['deal']['stepProd']['preparation']['installation']['images'],
              });
          }
          //console.log(data);
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch deal entity: \n' + error);
        }.bind(this)
      );
  }

  // Callback~
  getFiles(key, fileType, files) {
    let fileValid = true;
    console.log(files);
    if (files.file.size > file_upload_rules.sizeLimit) {
      // file too big
      this.props.openToast(false, 'La taille maximale autorisée est de 3Mo');
      fileValid = false;
    } else if (file_upload_rules.acceptedTypes.indexOf(files.file.type) === -1) {
      // file type not accepted
      this.props.openToast(false, 'Les formats autorisés sont jpeg, png et pdf');
      fileValid = false;
    }

    if (fileValid) {
      let stateIndex;
      switch (fileType) {
        case 'workOrder':
          stateIndex = 'filesWorkOrder';
          break;
        case 'trainingSheet':
          stateIndex = 'filesTrainingSheet';
          break;
        case 'image':
          stateIndex = 'filesImage';
          break;
      }
      let newFiles = this.state[stateIndex];
      newFiles[key] = files; // we need an int as the key
      this.setState({ [stateIndex]: newFiles });
    }
  }

  checkVirgin(associationsHardware, associationsVirtual) {
    let virgin = true;
    let finished = true;
    for (let i = 0; i < associationsHardware.length; i++) {
      for (let j = 0; j < associationsHardware[i].products.length; j++) {
        if (associationsHardware[i].products[j].installed) {
          virgin = false;
        } else {
          finished = false;
        }
      }
    }

    if (virgin || finished)
      for (let i = 0; i < associationsVirtual.length; i++) {
        for (let j = 0; j < associationsVirtual[i].products.length; j++) {
          if (associationsVirtual[i].products[j].installed) {
            virgin = false;
          } else {
            finished = false;
          }
        }
      }

    this.setState({
      isVirgin: virgin,
      isFinished: finished,
    });
  }

  toggleAppViewNavExtended() {
    this.setState({
      appViewNavExtended: !this.state.appViewNavExtended,
    });
  }

  addRowWorkOrder() {
    let newInput = `input-${this.state.fileInputsWorkOrder.length}`;
    this.setState({
      fileInputsWorkOrder: this.state.fileInputsWorkOrder.concat([newInput]),
    });
  }
  addRowTrainingSheet() {
    let newInput = `input-${this.state.fileInputsTrainingSheet.length}`;
    this.setState({
      fileInputsTrainingSheet: this.state.fileInputsTrainingSheet.concat([newInput]),
    });
  }
  addRowImage() {
    let newInput = `input-${this.state.fileInputsImage.length}`;
    this.setState({
      fileInputsImage: this.state.fileInputsImage.concat([newInput]),
    });
  }
  removeRowWorkOrder(key) {
    let new_fileInputs = this.state.fileInputsWorkOrder;
    let new_file = this.state.filesWorkOrder;
    new_fileInputs.splice(this.state.fileInputsWorkOrder.indexOf(key), 1);
    delete new_file[key];
    this.setState({
      fileInputsWorkOrder: new_fileInputs,
      filesWorkOrder: new_file,
    });
  }
  removeRowTrainingSheet(key) {
    let new_fileInputs = this.state.fileInputsTrainingSheet;
    let new_file = this.state.filesTrainingSheet;
    new_fileInputs.splice(this.state.fileInputsTrainingSheet.indexOf(key), 1);
    delete new_file[key];
    this.setState({
      fileInputsTrainingSheet: new_fileInputs,
      filesTrainingSheet: new_file,
    });
  }
  removeRowImage(key) {
    let new_fileInputs = this.state.fileInputsImage;
    let new_file = this.state.filesImage;
    new_fileInputs.splice(this.state.fileInputsImage.indexOf(key), 1);
    delete new_file[key];
    this.setState({
      fileInputsImage: new_fileInputs,
      filesImage: new_file,
    });
  }

  toggleAccordion(id) {
    let accordionMenu = { ...this.state.accordionMenu };
    accordionMenu[id] = !accordionMenu[id];
    this.setState({ accordionMenu });
  }

  isInstalled(products) {
    let res = true;

    for (let i = 0; i < products.length; i++) {
      if (!products[i].installed) {
        res = false;
        break;
      }
    }

    return res;
  }

  render() {
    const { savedWorkOrders } = this.state;
    const { savedTrainingSheets } = this.state;
    const { savedImages } = this.state;

    const { dataAssociationHardware } = this.state;
    const { dataAssociationVirtual } = this.state;

    let noQuoteHardware = '';
    let noQuoteVirtual = '';
    if (this.state.dataAssociationHardware != undefined && this.state.dataAssociationHardware.length == 0) {
      noQuoteHardware = <span>Aucun produit pour cette affaire.</span>;
    }
    if (this.state.dataAssociationVirtual != undefined && this.state.dataAssociationVirtual.length == 0) {
      noQuoteVirtual = <span>Aucun abonnement pour cette affaire.</span>;
    }

    const styles = {
      image: {
        width: '15px',
      },
    };

    let viewName = ' ';
    switch (this.state.selectedView) {
      case 1:
        viewName = 'Produit';
        break;
      case 2:
        viewName = 'Service';
        break;
      case 3:
        viewName = 'Documents';
        break;
    }

    return (
      <div id='appView' className='div-entity appSetup'>
        <SubNavBar
          toggleAppViewNavExtended={this.toggleAppViewNavExtended}
          goBack={this.props.history.goBack}
          appViewNavExtended={this.state.appViewNavExtended}
          title='Installation'
        >
          <div className={'appViewNavMenu-alignRight'}>
            <button onClick={() => this.openDocument('order')} type='button' className='btn btn-sm btn-outline-success'>
              <span className='icon icon-text-document'>Bon d'intervention</span>
            </button>
            <button
              onClick={() => this.openDocument('training')}
              type='button'
              className='btn btn-sm btn-outline-success'
            >
              <span className='icon icon-text-document'>Fiche de formation</span>
            </button>
          </div>
        </SubNavBar>

        <div id='appViewContent' className='listRefScroll'>
          <div className='timeline menu'>
            <div className='timeline-flex'>
              <div
                onClick={(newStep) => this.switchView(1)}
                className={'prep-step-number ' + (this.state.selectedView == 1 ? 'selected' : '')}
              >
                <img style={styles.image} src={hardwareIcon} />
              </div>
              <div
                onClick={(newStep) => this.switchView(2)}
                className={'prep-step-number ' + (this.state.selectedView == 2 ? 'selected' : '')}
              >
                <img style={styles.image} src={virtualIcon} />
              </div>
              <div
                onClick={(newStep) => this.switchView(3)}
                className={'prep-step-number ' + (this.state.selectedView == 3 ? 'selected' : '')}
              >
                <img style={styles.image} src={fileIcon} />
              </div>
            </div>
          </div>
          <div className='timeline-step-name'>
            <h3>{viewName}</h3>
          </div>

          {(this.state.selectedView == 1 || this.state.selectedView == 2) && (
            <div className='helper helper-panel-legend'>
              <span className='helper-label-legend lvl2'>Action requise</span>
              <span className='helper-label-legend lvl1'>En cours</span>
              {!this.state.isFinished ? (
                <button
                  onClick={() => this.openModalInstalledState(-1, 'all', true)}
                  type='button'
                  className='btn btn-sm btn-outline-success'
                >
                  <span className='icon icon-check'>Tout installer</span>
                </button>
              ) : (
                <span className='icon icon-check'>Tout installé</span>
              )}
            </div>
          )}

          {this.state.selectedView == 1 &&
            (dataAssociationHardware ? (
              dataAssociationHardware.map((data, i) => (
                <div key={data.id}>
                  <li
                    className={
                      'list-group-item entity-row spaced ' + (this.isInstalled(data.products) ? '' : 'marked-negative ')
                    }
                  >
                    <button
                      onClick={() => this.toggleAccordion('hardware-' + i)}
                      type='button'
                      className='btn btn-sm btn-outline-success'
                    >
                      <span
                        className={'icon icon-chevron-' + (this.state.accordionMenu['hardware-' + i] ? 'up ' : 'down ')}
                      ></span>
                    </button>
                    <span>{data.quoteArticle.productReference.wording}</span>
                    <span>{data.quoteArticle.quantity}</span>
                  </li>
                  {this.state.accordionMenu['hardware-' + i] &&
                    (data.products ? (
                      data.products.map((dataProduct) => (
                        <li
                          className={
                            'list-group-item entity-row indented-1 ' +
                            (!dataProduct.installed ? 'marked-negative ' : '')
                          }
                          key={dataProduct.id}
                        >
                          <Link to={linkToProductHardware + dataProduct.id}>
                            <span className='icon icon-shopping-cart'>{dataProduct.stickerId}</span>
                          </Link>
                          {!dataProduct.installed ? (
                            <button
                              onClick={() => this.openModalInstalledState(dataProduct.id, 'hardware')}
                              type='button'
                              className='btn btn-sm btn-outline-success'
                            >
                              <span className='icon icon-check'>Valider</span>
                            </button>
                          ) : (
                            <span>Installé / {moment(dataProduct.dateInstalled).format('DD-MM-YY | HH:mm')}</span>
                          )}
                        </li>
                      ))
                    ) : (
                      <li className='list-group-item'>Chargement...</li>
                    ))}
                </div>
              ))
            ) : (
              <li className='list-group-item'>Chargement...</li>
            ))}
          {this.state.selectedView == 1 && noQuoteHardware}

          {this.state.selectedView == 2 &&
            (dataAssociationVirtual ? (
              dataAssociationVirtual.map((data, i) => (
                <div key={data.id}>
                  <li
                    className={
                      'list-group-item entity-row spaced ' + (this.isInstalled(data.products) ? '' : 'marked-negative ')
                    }
                  >
                    <button
                      onClick={() => this.toggleAccordion('virtual-' + i)}
                      type='button'
                      className='btn btn-sm btn-outline-success'
                    >
                      <span
                        className={'icon icon-chevron-' + (this.state.accordionMenu['virtual-' + i] ? 'up ' : 'down ')}
                      ></span>
                    </button>
                    <span>{data.quoteArticle.productReference.wording}</span>
                    <span>{data.quoteArticle.quantity}</span>
                  </li>
                  {this.state.accordionMenu['virtual-' + i] &&
                    (data.quoteArticle.quantity <= itemsPerPage['association_product'] ? (
                      data.products ? (
                        data.products.map((dataProduct) => (
                          <li
                            className={
                              'list-group-item entity-row indented-1 ' +
                              (!dataProduct.installed ? 'marked-negative ' : '')
                            }
                            key={dataProduct.id}
                          >
                            <Link to={linkToProductVirtual + dataProduct.id}>
                              <span className='icon icon-shopping-cart'>#{dataProduct.id}</span>
                            </Link>
                            {!dataProduct.installed ? (
                              <button
                                onClick={() => this.openModalInstalledState(dataProduct.id, 'virtual')}
                                type='button'
                                className='btn btn-sm btn-outline-success'
                              >
                                <span className='icon icon-check'>Valider</span>
                              </button>
                            ) : (
                              <span>Installé / {moment(dataProduct.dateInstalled).format('DD-MM-YY | HH:mm')}</span>
                            )}
                          </li>
                        ))
                      ) : (
                        <li className='list-group-item'>Chargement...</li>
                      )
                    ) : (
                      <span>
                        Cette article a une quantité supérieure à {itemsPerPage['association_product']} unités.
                      </span>
                    ))}
                </div>
              ))
            ) : (
              <li className='list-group-item'>Chargement...</li>
            ))}
          {this.state.selectedView == 2 && noQuoteVirtual}

          {this.state.selectedView == 3 && (
            <div>
              <div className='alignHorizontal panelAppViewCat'>
                <img src={fileIcon} />
                <h6>Bon d'intervention</h6>
                <button type='button' className='btn btn-sm btn-outline-success'>
                  <span onClick={this.addRowWorkOrder} className='icon icon-plus'></span>
                </button>
              </div>
              {savedWorkOrders ? (
                savedWorkOrders.map((data) => (
                  <div key={data.id} className='alignHorizontal'>
                    <a target='_blank' href={'/' + data.name}>
                      <span className='icon icon-attachment'>
                        {data.name.split('/')[data.name.split('/').length - 1]}
                      </span>
                    </a>
                    <button
                      onClick={() => this.openModalDeleteFile(data.id, 'workOrder')}
                      type='button'
                      className='btn btn-sm btn-outline-success'
                    >
                      <span className='icon icon-cross'></span>
                    </button>
                  </div>
                ))
              ) : (
                <div className='alignHorizontal'>
                  <span>Chargement...</span>
                </div>
              )}
              {this.state.fileInputsWorkOrder.map((fileInput, key) => (
                <div className='alignHorizontal' key={key}>
                  <FileBase64
                    key={fileInput}
                    className='btn btn-sm btn-outline-success'
                    multiple={false}
                    onDone={this.getFiles.bind(this, fileInput, 'workOrder')}
                  />
                  <button
                    onClick={() => this.removeRowWorkOrder(fileInput)}
                    type='button'
                    className='btn btn-sm btn-outline-success'
                  >
                    <span className='icon icon-cross'></span>
                  </button>
                  {this.state.filesWorkOrder[fileInput] && this.state.filesWorkOrder[fileInput].base64 && (
                    <button
                      onClick={() => this.postFile(fileInput, 'workOrder')}
                      type='button'
                      className='btn btn-sm btn-outline-success'
                    >
                      <span className='icon icon-check'>Sauvegarder</span>
                    </button>
                  )}
                </div>
              ))}

              <hr />

              <div className='alignHorizontal panelAppViewCat'>
                <img src={fileIcon} />
                <h6>Fiche de formation</h6>
                <button type='button' className='btn btn-sm btn-outline-success'>
                  <span onClick={this.addRowTrainingSheet} className='icon icon-plus'></span>
                </button>
              </div>
              {savedTrainingSheets ? (
                savedTrainingSheets.map((data) => (
                  <div key={data.id} className='alignHorizontal'>
                    <a target='_blank' href={'/' + data.name}>
                      <span className='icon icon-attachment'>
                        {data.name.split('/')[data.name.split('/').length - 1]}
                      </span>
                    </a>
                    <button
                      onClick={() => this.openModalDeleteFile(data.id, 'trainingSheet')}
                      type='button'
                      className='btn btn-sm btn-outline-success'
                    >
                      <span className='icon icon-cross'></span>
                    </button>
                  </div>
                ))
              ) : (
                <div className='alignHorizontal'>
                  <span>Chargement...</span>
                </div>
              )}
              {this.state.fileInputsTrainingSheet.map((fileInput, key) => (
                <div className='alignHorizontal' key={key}>
                  <FileBase64
                    key={fileInput}
                    className='btn btn-sm btn-outline-success'
                    multiple={false}
                    onDone={this.getFiles.bind(this, fileInput, 'trainingSheet')}
                  />
                  <button
                    onClick={() => this.removeRowTrainingSheet(fileInput)}
                    type='button'
                    className='btn btn-sm btn-outline-success'
                  >
                    <span className='icon icon-cross'></span>
                  </button>
                  {this.state.filesTrainingSheet[fileInput] && this.state.filesTrainingSheet[fileInput].base64 && (
                    <button
                      onClick={() => this.postFile(fileInput, 'trainingSheet')}
                      type='button'
                      className='btn btn-sm btn-outline-success'
                    >
                      <span className='icon icon-check'>Sauvegarder</span>
                    </button>
                  )}
                </div>
              ))}

              <hr />

              <div className='alignHorizontal panelAppViewCat'>
                <img src={fileIcon} />
                <h6>Image Installation</h6>
                <button type='button' className='btn btn-sm btn-outline-success'>
                  <span onClick={this.addRowImage} className='icon icon-plus'></span>
                </button>
              </div>
              {savedImages ? (
                savedImages.map((data) => (
                  <div key={data.id} className='alignHorizontal'>
                    <a target='_blank' href={'/' + data.name}>
                      <span className='icon icon-attachment'>
                        {data.name.split('/')[data.name.split('/').length - 1]}
                      </span>
                    </a>
                    <button
                      onClick={() => this.openModalDeleteFile(data.id, 'image')}
                      type='button'
                      className='btn btn-sm btn-outline-success'
                    >
                      <span className='icon icon-cross'></span>
                    </button>
                  </div>
                ))
              ) : (
                <div className='alignHorizontal'>
                  <span>Chargement...</span>
                </div>
              )}
              {this.state.fileInputsImage.map((fileInput, key) => (
                <div className='alignHorizontal' key={key}>
                  <FileBase64
                    key={fileInput}
                    className='btn btn-sm btn-outline-success'
                    multiple={false}
                    onDone={this.getFiles.bind(this, fileInput, 'image')}
                  />
                  <button
                    onClick={() => this.removeRowImage(fileInput)}
                    type='button'
                    className='btn btn-sm btn-outline-success'
                  >
                    <span className='icon icon-cross'></span>
                  </button>
                  {this.state.filesImage[fileInput] && this.state.filesImage[fileInput].base64 && (
                    <button
                      onClick={() => this.postFile(fileInput, 'image')}
                      type='button'
                      className='btn btn-sm btn-outline-success'
                    >
                      <span className='icon icon-check'>Sauvegarder</span>
                    </button>
                  )}
                </div>
              ))}
            </div>
          )}

          <ModalReturnEmployee
            className='myModal'
            modalText={this.state.textModal}
            employeeRequired={true}
            isOpen={this.state.isModalReturnEmployee}
            openToast={this.props.openToast}
            onPostResult={this.markAsInstalled}
            onClose={this.closeModal}
          />

          <ModalConfirm
            className='myModal'
            modalText={this.state.textModal}
            isOpen={this.state.isModalInstalledOpen}
            onSubmit={this.markAsInstalled}
            onClose={this.closeModal}
            onCancel={this.closeModal}
          ></ModalConfirm>

          <ModalConfirm
            className='myModal'
            modalText={this.state.textModal}
            isOpen={this.state.isModalDeleteOpen}
            onSubmit={this.deleteFile}
            onClose={this.closeModal}
            onCancel={this.closeModal}
          ></ModalConfirm>
        </div>
      </div>
    );
  }

  openModalInstalledState(productId, type, markAll = false) {
    let modal = {
      title: 'Installation',
      message:
        'Vous allez modifiez l\'état en "installé".' +
        (this.state.isVirgin
          ? "Il s'agit du premier produit/service installé pour cette affaire. Veuillez indiquer l'employée en charge de la facturation."
          : ''),
    };
    this.props.toggleBlackOut();
    let toOpen = this.state.isVirgin ? 'isModalReturnEmployee' : 'isModalInstalledOpen';
    this.setState({
      markAll: markAll,
      textModal: modal,
      [toOpen]: true,
      productSelectedId: productId,
      productSelectedType: type,
    });
  }

  openModalDeleteFile(productId, type) {
    let modal = {
      title: 'Suppression',
      message: 'Vous allez supprimer le fichier',
    };
    this.props.toggleBlackOut();
    this.setState({
      textModal: modal,
      isModalDeleteOpen: true,
      productSelectedId: productId,
      productSelectedType: type,
    });
  }

  closeModal() {
    this.props.toggleBlackOut();
    this.setState({
      isModalReturnEmployee: false,
      isModalInstalledOpen: false,
      isModalDeleteOpen: false,
    });
  }

  markAsInstalled(employeeId = undefined) {
    if (this.state.markAll) {
      this.markAllInstalled(employeeId);
    } else {
      this.markOneInstalled(employeeId);
    }
  }

  markOneInstalled(employeeId = undefined) {
    let graphKey = this.state.productSelectedType == 'hardware' ? 'productsHardware' : 'productsVirtual';
    let queryURL = apiUpdateInstallation;
    let graphQL =
      'mutation { listingProducts(dealId:' +
      this.props.match.params.id +
      ', ' +
      graphKey +
      ':[{id:' +
      this.state.productSelectedId +
      ', installed:' +
      true +
      '}]';
    if (employeeId) {
      graphQL += ', billMakerId:' + employeeId;
    }
    graphQL += '){ ' + graphKey + '{id, installed} }}';
    queryURL += graphQL;
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'POST',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          if (data['data']['listingProducts'][graphKey][0]['installed'] == true) {
            this.refreshAssociations();
            this.props.openToast(true, "L'état de l'installation a été actualisé");
            if (employeeId) {
              this.setState({
                isVirgin: false,
              });
            }
          } else {
            this.props.openToast(false, 'Erreur modification installation. Veuillez réessayer');
          }
        }.bind(this)
      )
      .catch(
        function (rror) {
          this.props.openToast(false, 'Erreur modification installation. Veuillez réessayer');
          console.log(rror);
        }.bind(this)
      );
  }

  markAllInstalled(employeeId = undefined) {
    let queryURL = apiUpdateInstallation;
    let graphQL = 'mutation{ listingProducts(all:true,dealId:' + this.props.match.params.id;
    if (employeeId) {
      graphQL += ', billMakerId:' + employeeId;
    }
    graphQL += '){ productsHardware{id, installed}, productsVirtual{ id, installed} } }';
    queryURL += graphQL;
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'POST',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          if (data['data']) {
            this.refreshAssociations();
            this.props.openToast(true, "L'état de l'installation a été actualisé");
            this.setState({
              isVirgin: false,
              isFinished: true,
            });
          } else {
            this.props.openToast(false, 'Erreur modification installation. Veuillez réessayer');
          }
        }.bind(this)
      )
      .catch(
        function (rror) {
          this.props.openToast(false, 'Erreur modification installation. Veuillez réessayer');
          console.log(rror);
        }.bind(this)
      );
  }

  postFile(fileInput, fileType) {
    let stateIndex;
    let graphKey;
    switch (fileType) {
      case 'workOrder':
        stateIndex = 'filesWorkOrder';
        graphKey = 'workOrder';
        break;
      case 'trainingSheet':
        stateIndex = 'filesTrainingSheet';
        graphKey = 'trainingSheet';
        break;
      case 'image':
        stateIndex = 'filesImage';
        graphKey = 'installPicture';
        break;
    }

    let file;
    file = this.state[stateIndex][fileInput];
    console.log(file);

    let payload = {
      deal: {
        id: this.props.match.params.id,
      },
      [graphKey]: {
        typeOfFile: file.type.split('/')[1],
        filename: file.filename,
      },
    };

    let data = 'metadata=' + encodeURIComponent(JSON.stringify(payload));
    data += '&';
    data += 'base64=' + encodeURIComponent(file.base64.split('base64,')[1]);

    this.props
      .authFetch(apiInstallationAddFile, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        method: 'POST',
        body: data,
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          // perform setState here
          let isValid = data.isValid;
          console.log(data);
          if (isValid) {
            this.componentDidMount();
            this.setState({ selectedView: 3 });
            this.props.openToast(true, 'Le fichier a été sauvegardé');
            switch (fileType) {
              case 'workOrder':
                this.removeRowWorkOrder(fileInput);
                break;
              case 'trainingSheet':
                this.removeRowTrainingSheet(fileInput);
                break;
              case 'image':
                this.removeRowImage(fileInput);
                break;
            }
          } else {
            //this.setState({ uploadState: "failed" });
            this.props.openToast(false, 'Erreur sauvegarde. Veuillez réessayer');
          }
        }.bind(this)
      )
      .catch(
        function (rror) {
          console.log(rror);
          this.props.openToast(false, 'Erreur sauvegarde. Veuillez réessayer');
        }.bind(this)
      );
  }

  deleteFile() {
    let apiDelete;
    let graphKey;
    switch (
      this.state.productSelectedType // use the "product" to save variables
    ) {
      case 'workOrder':
        apiDelete = apiRemoveWorkOrder;
        graphKey = 'workOrder';
        break;
      case 'trainingSheet':
        apiDelete = apiRemoveTrainingSheet;
        graphKey = 'trainingSheet';
        break;
      case 'image':
        apiDelete = apiRemoveImage;
        graphKey = 'installPicture';
        break;
    }

    let json = {
      [graphKey]: {
        id: this.state.productSelectedId,
      },
    };
    let queryURL = apiDelete;
    queryURL += encodeURIComponent(JSON.stringify(json));
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'DELETE',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          let isValid = data.isValid;
          if (isValid) {
            this.componentDidMount();
            this.setState({ selectedView: 3 });
            this.props.openToast(true, 'Vous venez de supprimer le fichier');
          } else {
            this.props.openToast(false, 'Erreur suppression fichier. Veuillez réessayer');
          }
        }.bind(this)
      )
      .catch(
        function (rror) {
          this.props.openToast(false, 'Erreur suppression fichier. Veuillez réessayer');
          console.log(rror);
        }.bind(this)
      );
  }

  openDocument(type) {
    let link = '';
    switch (type) {
      case 'order':
        link = linkDocumentWorkOrder;
        break;
      case 'training':
        link = linkDocumentTrainingSheet;
        break;
    }
    let tab = window.open(link);
    tab.focus();
    this.setState({ extendedNav: false });
  }

  switchView(newStep) {
    this.setState({
      selectedView: newStep,
    });
  }
}

export default withAuth(AppInstallation);
